import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_3 = { class: "pt-0 mt-0 text-gray-800" }
const _hoisted_4 = { class: "space-y-2.5" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "space-y-2.5" }
const _hoisted_7 = { class: "space-y-2.5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select a Country", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select a Setting", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex items-center space-x-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "to", -1)
const _hoisted_14 = { class: "mb-2 text-sm italic" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "hidden w-full table-auto md:table" }
const _hoisted_17 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_18 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_19 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_20 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_21 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}, null, -1)
const _hoisted_23 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_24 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_25 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_26 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_27 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "block md:hidden" }
const _hoisted_30 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "Date", -1)
const _hoisted_32 = { class: "w-full px-2 py-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "Start time", -1)
const _hoisted_34 = { class: "w-full px-2 py-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "End time", -1)
const _hoisted_36 = { class: "w-full px-2 py-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "Timezone", -1)
const _hoisted_38 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "hidden p-4 mt-6 bg-gray-200 rounded md:block" }
const _hoisted_41 = { class: "mt-4" }
const _hoisted_42 = { class: "flex items-center space-x-2" }
const _hoisted_43 = { value: 1 }
const _hoisted_44 = { value: 2 }
const _hoisted_45 = { value: 3 }
const _hoisted_46 = { value: 4 }
const _hoisted_47 = { value: 5 }
const _hoisted_48 = { value: 6 }
const _hoisted_49 = { value: 0 }
const _hoisted_50 = { class: "inline w-32" }
const _hoisted_51 = { class: "w-32" }
const _hoisted_52 = { class: "p-4 mt-6 bg-gray-200 rounded md:hidden" }
const _hoisted_53 = { class: "mt-4" }
const _hoisted_54 = { class: "flex flex-wrap items-center space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_55 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_56 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_57 = { value: 1 }
const _hoisted_58 = { value: 2 }
const _hoisted_59 = { value: 3 }
const _hoisted_60 = { value: 4 }
const _hoisted_61 = { value: 5 }
const _hoisted_62 = { value: 6 }
const _hoisted_63 = { value: 0 }
const _hoisted_64 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_65 = { class: "w-full md:w-32" }
const _hoisted_66 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", null, "and", -1)
const _hoisted_68 = { class: "w-full md:w-32" }
const _hoisted_69 = { class: "pt-0 mt-0 text-gray-800" }
const _hoisted_70 = { class: "flex flex-wrap gap-4 py-6" }

import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import DefaultButton from "@/components/DefaultButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import { formatDate, getTimezoneInfo } from "@/utils/dates";
import { addMultiClubDatesUtil } from "@/utils/clubs";
import { brickClubsSettingOptions } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditClubPage',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();
const { short_timezone, timezone, user } = storeToRefs(useUserStore());
const { countries } = storeToRefs(useGlobalStore());

const isDraftSaving = ref(false);
const settings = brickClubsSettingOptions;

const datepicker = ref(null);
const first_club_date_datepicker = ref(null);
const last_club_date_datepicker = ref(null);

const dates = ref([] as any[]);
const club = ref();

const multiDates = ref({
  amount: 0,
  day: 1,
  start_time: "",
  end_time: "",
});

function isDateInPast(date: Date) {
  // Return true or false if date is in the past
  return new Date(date) < new Date();
}

function setDate(date: Date, ref: string) {
  if (!date) return;

  club.value[ref] = formatDate(date);

  if (ref === "first_club_date") {
    // @ts-ignore
    first_club_date_datepicker.value.closeMenu();
  }

  if (ref === "last_club_date") {
    // @ts-ignore
    last_club_date_datepicker.value.closeMenu();
  }
}

function setScheduleDate(i: number, date: Date) {
  if (!date) return;

  const { short_timezone, timezone_offset } = getTimezoneInfo(date, timezone.value);

  dates.value[i] = {
    date: formatDate(date),
    start_time: dates.value[i].start_time,
    end_time: dates.value[i].end_time,
    timezone: timezone.value,
    short_timezone,
    timezone_offset,
  };

  // @ts-ignore
  datepicker.value[i].closeMenu();
}

function addClubDate() {
  dates?.value.push({
    date: "",
    start_time: "",
    end_time: "",
    brick_club_id: club.value.id,
    timezone: timezone.value,
    short_timezone: short_timezone.value,
  });
}

async function addMultiClubDates() {
  addMultiClubDatesUtil({
    dates,
    multiDates,
    timezone
  });
}

function removeClubDate(index: number) {
  if (index === 0) {
    return;
  }

  dates.value.splice(index, 1);
}

async function saveClub() {
  try {
    // Filter out any empty dates
    dates.value = dates.value.filter(date => date.date !== "" && date.start_time !== "" && date.end_time !== "");

    const response = await api.clubs.updateClub(Number(route.params.id!), {
      club: club.value,
      dates: dates.value,
    });

    globalStore.toast("SUCCESS", "Brick Club updating");
    return (window.location.href = `/dashboard/clubs/${response.data.club.id}`);
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error updating Brick Club");
    isDraftSaving.value = false;
  }
}

club.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.clubs.getClub(route.params.id as string))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.club;
dates.value = club.value.dates;

if (!user.value.has_brick_club_access) {
  window.location.href = "/dashboard";
}

watch(
  () => club.value.first_club_date,
  () => {
    dates.value[0].date = club.value.first_club_date;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('club-details')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        class: "mt-8",
        onSubmit: _withModifiers(saveClub, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ListRowItem, {
            title: _ctx.$t('brick-club-name'),
            required: true,
            capitalize: false
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((club.value.name) = $event)),
                placeholder: "Brick Club Name",
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                required: ""
              }, null, 512), [
                [_vModelText, club.value.name]
              ]),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("club-page-name-warning")), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('first-club-date'),
            required: true,
            capitalize: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DatePicker, {
                required: "",
                ref_key: "first_club_date_datepicker",
                ref: first_club_date_datepicker,
                onInternalModelChange: _cache[1] || (_cache[1] = e => setDate(e, 'first_club_date')),
                modelValue: club.value.first_club_date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((club.value.first_club_date) = $event)),
                "min-date": new Date(),
                format: "dd/MMM/yyyy"
              }, null, 8, ["modelValue", "min-date"])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('last-club-date'),
            capitalize: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DatePicker, {
                ref_key: "last_club_date_datepicker",
                ref: last_club_date_datepicker,
                onInternalModelChange: _cache[3] || (_cache[3] = e => setDate(e, 'last_club_date')),
                modelValue: club.value.last_club_date,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((club.value.last_club_date) = $event)),
                "min-date": new Date(),
                format: "dd/MMM/yyyy"
              }, null, 8, ["modelValue", "min-date"])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('brick-club-contact-email'),
            required: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(user).directory_email_address) = $event)),
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _unref(user).directory_email_address]
                ]),
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('brick-club-contact-email-helptext')
                }, null, 8, _hoisted_5)
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('brick-club-website'),
            required: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(user).directory_website) = $event)),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _unref(user).directory_website]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('venue'),
            required: true,
            capitalize: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "address-line-1",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((club.value.address_line_one) = $event)),
                  placeholder: "Address Line 1",
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  required: ""
                }, null, 512), [
                  [_vModelText, club.value.address_line_one]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "address-line-two",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((club.value.address_line_two) = $event)),
                  placeholder: "Address Line 2 (optional)",
                  class: "block w-full h-10 py-2 text-gray-900 border rounded border-gray-00"
                }, null, 512), [
                  [_vModelText, club.value.address_line_two]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "city",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((club.value.city) = $event)),
                  placeholder: "City",
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  required: ""
                }, null, 512), [
                  [_vModelText, club.value.city]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "postcode",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((club.value.region) = $event)),
                  placeholder: "State/Region",
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  required: ""
                }, null, 512), [
                  [_vModelText, club.value.region]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "postcode",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((club.value.postcode) = $event)),
                  placeholder: "Postcode",
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  required: ""
                }, null, 512), [
                  [_vModelText, club.value.postcode]
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    id: "subscription",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((club.value.country) = $event)),
                    class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                    required: ""
                  }, [
                    _hoisted_8,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                      return (_openBlock(), _createElementBlock("option", {
                        class: "capitalize",
                        value: country.name,
                        key: country.name
                      }, _toDisplayString(country.name), 9, _hoisted_9))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, club.value.country]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('setting'),
            required: true,
            capitalize: false
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                id: "setting",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((club.value.setting) = $event)),
                class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                required: ""
              }, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings), (setting, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: "capitalize",
                    value: setting,
                    key: index
                  }, _toDisplayString(_ctx.$t(setting)), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, club.value.setting]
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('age-range'),
            required: true,
            capitalize: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "1",
                  max: "100",
                  step: "1",
                  oninput: "this.value=(Math.ceil(this.value))",
                  id: "name",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((club.value.min_age) = $event)),
                  placeholder: "Min. Age",
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  required: ""
                }, null, 512), [
                  [_vModelText, club.value.min_age]
                ]),
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "1",
                  max: "100",
                  step: "1",
                  oninput: "this.value=(Math.ceil(this.value))",
                  id: "name",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((club.value.max_age) = $event)),
                  placeholder: "Min. Age",
                  class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                  required: ""
                }, null, 512), [
                  [_vModelText, club.value.max_age]
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: "Schedule",
            flex: false,
            capitalize: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("first-club-date-helptext")), 1)
              ]),
              _createElementVNode("p", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t("all-times-are-in-short_timezone", [_unref(short_timezone)])), 1),
                _hoisted_15,
                _createTextVNode(_toDisplayString(_ctx.$t("timezone-helptext")), 1)
              ]),
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_17, [
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("date")), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t("start-time")), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("end-time")), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("timezone")), 1),
                    _hoisted_22
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "border-b border-gray-400 divide-x-2 divide-gray-400 bg-play-gray",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_23, [
                        _createVNode(_component_DatePicker, {
                          ref_for: true,
                          ref_key: "datepicker",
                          ref: datepicker,
                          format: "dd/MMM/yyyy",
                          modelValue: date.date,
                          "onUpdate:modelValue": ($event: any) => ((date.date) = $event),
                          "enable-time-picker": false,
                          disabled: isDateInPast(date.date),
                          onInternalModelChange: e => setScheduleDate(index, e)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onInternalModelChange"])
                      ]),
                      _createElementVNode("td", _hoisted_24, [
                        _createVNode(_component_DatePicker, {
                          "time-picker": "",
                          disabled: isDateInPast(date.date),
                          modelValue: date.start_time,
                          "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                          "model-type": "HH:mm"
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createVNode(_component_DatePicker, {
                          "time-picker": "",
                          disabled: isDateInPast(date.date),
                          modelValue: date.end_time,
                          "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                          "model-type": "HH:mm"
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("span", null, _toDisplayString(date.short_timezone), 1)
                      ]),
                      _createElementVNode("td", _hoisted_27, [
                        (index !== 0 && !isDateInPast(date.date))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "mx-2 underline text-blue",
                              onClick: ($event: any) => (removeClubDate(index)),
                              type: "button"
                            }, _toDisplayString(_ctx.$t("delete")), 9, _hoisted_28))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex flex-wrap border-b-2 border-gray-300 bg-play-gray",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_DatePicker, {
                        "enable-time-picker": false,
                        format: "dd/MMM/yyyy",
                        class: "mt-1",
                        modelValue: date.date,
                        "onUpdate:modelValue": ($event: any) => ((date.date) = $event),
                        disabled: isDateInPast(date.date)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode(_component_DatePicker, {
                        "time-picker": "",
                        disabled: isDateInPast(date.date),
                        modelValue: date.start_time,
                        "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                        class: "mt-1",
                        "model-type": "HH:mm"
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_DatePicker, {
                        "time-picker": "",
                        disabled: isDateInPast(date.date),
                        modelValue: date.end_time,
                        "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                        class: "mt-1",
                        "model-type": "HH:mm"
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("span", null, _toDisplayString(date.short_timezone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "mx-2 underline text-blue",
                            onClick: ($event: any) => (removeClubDate(index))
                          }, _toDisplayString(_ctx.$t("delete")), 9, _hoisted_39))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(DefaultButton, {
                type: "primary",
                disabled: !dates.value[dates.value.length - 1].date,
                class: "mt-4",
                onAction: addClubDate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("add-another-date")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("if-your-brick-club-occurs-at-the-same-time-every-week-use-the-below-input-to-add-dates-quickly")), 1),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("add")), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((multiDates.value.amount) = $event)),
                      placeholder: "1",
                      class: "w-32 h-10 py-2 mx-2 text-gray-900 border border-gray-600 rounded",
                      type: "number",
                      min: "0"
                    }, null, 512), [
                      [_vModelText, multiDates.value.amount]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("weeks-of-sessions")), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((multiDates.value.day) = $event)),
                      class: "w-32 h-10 py-2 mx-2 text-gray-900 border border-gray-600 rounded"
                    }, [
                      _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("monday")), 1),
                      _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t("tuesday")), 1),
                      _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t("wednesday")), 1),
                      _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.$t("thursday")), 1),
                      _createElementVNode("option", _hoisted_47, _toDisplayString(_ctx.$t("friday")), 1),
                      _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t("saturday")), 1),
                      _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t("sunday")), 1)
                    ], 512), [
                      [_vModelSelect, multiDates.value.day]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("between")), 1),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_DatePicker, {
                        "time-picker": "",
                        modelValue: multiDates.value.start_time,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((multiDates.value.start_time) = $event)),
                        class: "mt-1",
                        "model-type": "HH:mm"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("and")), 1),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_DatePicker, {
                        "time-picker": "",
                        modelValue: multiDates.value.end_time,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((multiDates.value.end_time) = $event)),
                        class: "mt-1",
                        "model-type": "HH:mm"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode(DefaultButton, {
                    type: "primary",
                    class: "mt-4",
                    onAction: addMultiClubDates
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("add-multiple-dates")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("if-your-brick-club-occurs-at-the-same-time-every-week-use-the-below-input-to-add-dates-quickly")), 1),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("add")), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((multiDates.value.amount) = $event)),
                        placeholder: "1",
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded md:mx-2 md:w-32",
                        type: "number",
                        min: "0"
                      }, null, 512), [
                        [_vModelText, multiDates.value.amount]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("weeks-of-sessions")), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((multiDates.value.day) = $event)),
                        class: "w-full h-10 py-2 text-gray-900 border border-gray-600 rounded md:w-32 md:mx-2"
                      }, [
                        _createElementVNode("option", _hoisted_57, _toDisplayString(_ctx.$t("monday")), 1),
                        _createElementVNode("option", _hoisted_58, _toDisplayString(_ctx.$t("tuesday")), 1),
                        _createElementVNode("option", _hoisted_59, _toDisplayString(_ctx.$t("wednesday")), 1),
                        _createElementVNode("option", _hoisted_60, _toDisplayString(_ctx.$t("thursday")), 1),
                        _createElementVNode("option", _hoisted_61, _toDisplayString(_ctx.$t("friday")), 1),
                        _createElementVNode("option", _hoisted_62, _toDisplayString(_ctx.$t("saturday")), 1),
                        _createElementVNode("option", _hoisted_63, _toDisplayString(_ctx.$t("sunday")), 1)
                      ], 512), [
                        [_vModelSelect, multiDates.value.day]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("between")), 1),
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_DatePicker, {
                          "time-picker": "",
                          modelValue: multiDates.value.start_time,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((multiDates.value.start_time) = $event)),
                          class: "mt-1",
                          "model-type": "HH:mm"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_DatePicker, {
                          "time-picker": "",
                          modelValue: multiDates.value.end_time,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((multiDates.value.end_time) = $event)),
                          class: "mt-1",
                          "model-type": "HH:mm"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode(DefaultButton, {
                    type: "primary",
                    class: "mt-4",
                    onAction: addMultiClubDates
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("add-multiple-dates")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, {
            title: _ctx.$t('capacity-of-club'),
            required: true,
            capitalize: false
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "0",
                step: "1",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((club.value.participants_count) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
              }, null, 512), [
                [_vModelText, club.value.participants_count]
              ]),
              _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.$t("capacity-of-club-helptext")), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _createVNode(DefaultButton, {
            id: "published",
            type: "primary",
            "is-form-submit": true,
            loading: isDraftSaving.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("save-brick-club")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 40, _hoisted_1)
    ])
  ], 64))
}
}

})